import { Asset } from 'app-lib/assetUtils'
import { Button, Input, SliderPercent } from 'bzx-common/src/ui-framework'
import _ from 'lodash'
import React, { Component } from 'react'
import AssetDropdown from 'shared-components/AssetDropdown'

interface IInputAmountProps {
  inputAmount: string
  isLoading: boolean
  selectedAsset: Asset
  buttonValue?: number
  selectorAssets?: Asset[]
  withSlider?: boolean
  readonly?: boolean
  maxSliderValue?: number
  ratio?: number
  max?: boolean
  noButtonOrSlider?: boolean
  sliderAbove?: boolean
  className?: string
  isGrouped?: boolean
  onInsertMaxValue?: (value: number) => void
  onAmountChange?: (value: string) => void
  onCollateralChange?: (asset: Asset) => void
  onAfterSliderChange?: () => void
}

interface IInputAmountState {
  prevInputAmount: number
}

export class InputAmount extends Component<IInputAmountProps, IInputAmountState> {
  constructor(props: IInputAmountProps) {
    super(props)
    this.state = { prevInputAmount: 0 }
  }

  public render() {
    const ratio = _.isFinite(this.props.ratio) ? _.min([this.props.ratio, 1]) || 1 : 1
    const { isGrouped } = this.props
    const maxSliderValue = (this.props.maxSliderValue || 100) * ratio
    const wrapperClass = `input-amount ${isGrouped ? '' : ''}${this.props.className || ''}`

    return (
      <div className={wrapperClass}>
        {this.props.children}
        <div className="flex-col">
          <div
            className={isGrouped ? 'input-amount__container--grouped' : 'input-amount__container'}>
            <Input
              className={'txt-default ' + (isGrouped ? 'border-0 bg-transparent' : '')}
              name="amount-input"
              type="text"
              value={this.props.inputAmount}
              onChange={this.props.onAmountChange}
              onChangeEmit="value"
              readOnly={this.props.readonly}
              isLoading={this.props.isLoading}
              withLoader
            />

            {!this.props.max ? (
              this.props.selectorAssets ? (
                <AssetDropdown
                  selectedAsset={this.props.selectedAsset}
                  onAssetChange={this.props.onCollateralChange}
                  assets={this.props.selectorAssets}
                  className="margin-left-1"
                />
              ) : (
                <AssetDropdown
                  selectedAsset={this.props.selectedAsset}
                  assets={[this.props.selectedAsset]}
                  className="margin-left-1"
                />
              )
            ) : (
              <Button
                variant="blue"
                onClick={this.props.onInsertMaxValue}
                className={`input-amount__max-addon ${!isGrouped ? 'margin-left-1' : ''}`}>
                Max
              </Button>
            )}
          </div>
        </div>
        {!this.props.withSlider || !this.props.onInsertMaxValue ? (
          !this.props.noButtonOrSlider ? (
            <div className="input-amount__group-button margin-top-2">
              <Button
                variant="white"
                size="narrow"
                active={this.props.buttonValue === 0.25}
                data-value="0.25"
                onClick={this.setButtonValue}
                disabled={ratio < 0.25}>
                25%
              </Button>
              <Button
                variant="white"
                size="narrow"
                active={this.props.buttonValue === 0.5}
                data-value="0.5"
                onClick={this.setButtonValue}
                disabled={ratio < 0.5}>
                50%
              </Button>
              <Button
                variant="white"
                size="narrow"
                active={this.props.buttonValue === 0.75}
                data-value="0.75"
                onClick={this.setButtonValue}
                disabled={ratio < 0.75}>
                75%
              </Button>
              <Button
                variant="white"
                size="narrow"
                active={this.props.buttonValue === ratio}
                data-value={ratio > 1 ? '1' : ratio}
                onClick={this.setButtonValue}
                disabled={ratio === 0}>
                {ratio < 1 ? 'MAX' : '100%'}
              </Button>
            </div>
          ) : null
        ) : (
          <SliderPercent
            className="margin-top-2"
            onInsertMaxValue={this.props.onInsertMaxValue}
            percentSlider={this.props.buttonValue || 0}
            maxSliderValue={maxSliderValue}
            onAfterChange={this.props.onAfterSliderChange}
          />
        )}
      </div>
    )
  }

  public setButtonValue = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    const buttonElement = event.currentTarget as HTMLButtonElement
    if (buttonElement.dataset.value) {
      const value = parseFloat(buttonElement.dataset.value)
      this.props.onInsertMaxValue && this.props.onInsertMaxValue(value)
    }
  }
}
